import { Injectable } from '@angular/core';
import {catchError, Observable, retry} from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {HelperService} from "../../helper.service";
import {BaseService} from "../../services/base.service";
import {AttachmentModel} from "../models-otc/attachment-model";
import {tap} from "rxjs/operators";
import {NavBarComponent} from "../../nav-bar/nav-bar.component";

@Injectable({
    providedIn: 'root'
})
export class AttachmentsService extends BaseService {

    constructor(
        private httpClient: HttpClient,
        public snackBar: MatSnackBar,
        public helper: HelperService,
        public nav: NavBarComponent,
    ) {
        super();
    }

    /// GET ///
    getAttachmentList(orderId:number): Observable<AttachmentModel[]> {
        return this.httpClient.get<AttachmentModel[]>(this.OTC_BASE_URL + `orders/${orderId}/attachments`)
            .pipe(
                retry(1),
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving Attachment','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

    downloadAttachment(id:number): Observable<Blob> {
        return this.httpClient.get(this.OTC_BASE_URL + `orders/attachments/${id}/download`, { responseType: 'blob' } )
            .pipe(
                retry(1),
                catchError(err => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Downloading Attachment','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                }),
                tap(() => {
                    this.snackBar.open('Download Successful', 'close', {
                        duration: 5000,
                    });
                })
            )
    }

    /// POST ///
    postNewAttachment(orderId: number, description: string, file: File): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);

        return this.httpClient.post<any>(this.OTC_BASE_URL + `orders/${orderId}/attachments?description=${description}`, formData).pipe(
            retry(1),
            catchError((err) => {
                this.hasError.next(true);
                this.snackBar.open('Error Adding New Attachment', 'close', {
                    duration: 5000,
                });
                this.hasError.next(false);
                return this.errorHandler(err);
            }));

    }


    /// PUT ///
    updateAttachmentDescription(id: number, description: string): Observable<AttachmentModel> {
        return this.httpClient.put<AttachmentModel>(this.OTC_BASE_URL +`orders/attachments` , {id:id,description:description})
            .pipe(
                retry(1),
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Updating Attachment','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                }),
                tap(() => {
                    this.snackBar.open('Update Successful', 'close', {
                        duration: 5000,
                    });
                })
            );
    }

/// DELETE ///
    deleteAttachmentListItem(id: number): Observable<string> {
        return this.httpClient.delete(this.OTC_BASE_URL + `orders/attachments/${id}`,{ responseType: 'text'})
            .pipe(
                retry(0),
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Removing Attachment','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                }),
                tap(() => {
                    this.snackBar.open('Attachment Removed Successfully', 'close', {
                        duration: 5000,
                    });
                })
            );
    }
}
